/**
 * Actions for the Preferences component
 * Contains action creators that dispatch Redux actions to control preferences state
 */
import { store } from '../../redux/store';
import { showPreferences, hidePreferences, toggleDarkMode, setProfession } from './reducer';

/**
 * Opens the preferences modal
 * Dispatches the showPreferences action to the Redux store
 */
export const openPreferences = () => {
  store.dispatch(showPreferences());
};

/**
 * Closes the preferences modal
 * Dispatches the hidePreferences action to the Redux store
 */
export const closePreferences = () => {
  store.dispatch(hidePreferences());
};

/**
 * Toggles between light and dark theme
 * Dispatches the toggleDarkMode action to the Redux store
 */
export const toggleTheme = () => {
  store.dispatch(toggleDarkMode());
};

/**
 * Updates the user's profession in the preferences state
 *
 * @param profession - The profession identifier to set
 */
export const updateProfession = (profession: string) => {
  store.dispatch(setProfession(profession));
};
